import { hrefFromPageDoc } from '@/utilities/hrefFromPageDoc'

export type BotaoLike = {
  rotulo?: string | null
  variante?: string | null
  novaAba?: boolean | null
  pagina?: number | string | { slug?: string | null; fullPath?: string | null } | null
  url?: string | null
  corFundo?: string | null
  corTexto?: string | null
  mostrarSeta?: boolean | null
}

/** Página interna (populada) tem prioridade; depois a URL/âncora; vazio → `null` (não renderiza). */
export function resolverHrefBotao(b: BotaoLike | null | undefined): string | null {
  if (!b) return null
  if (b.pagina && typeof b.pagina === 'object') {
    return hrefFromPageDoc(b.pagina)
  }
  const url = typeof b.url === 'string' ? b.url.trim() : ''
  return url || null
}

/** Botão «ativo» = tem rótulo e destino. */
export function botaoValido(b: BotaoLike | null | undefined): boolean {
  return Boolean(b && typeof b.rotulo === 'string' && b.rotulo.trim() && resolverHrefBotao(b))
}
